var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chip"},[_c('div',{staticClass:"chip__circle"}),_c('p',{staticClass:"chip__label"},[_vm._v(_vm._s(_vm.$t('SPORTS_WEBAPP_LIVE')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }